import { Navigate } from 'react-router-dom';
import { usePermission } from '../hooks/usePermission';

export default function PermissionRoute({ permission, children }) {
  const hasPermission = usePermission(permission);
  return hasPermission ? children : <Navigate to="/forbidden" replace />;
}
